import axios from './axios'

export const createSubInvoice = ({ data }) => axios.post('sub_invoices', data)
export const deleteSubInvoice = ({ id }) => axios.delete(`sub_invoices/${id}`)
export const findSubInvoice = ({ id, params } = {}) => axios.get(`sub_invoices/${id}`, { params })
export const getSubInvoices = ({ params } = {}) => axios.get('sub_invoices', { params })
export const updateSubInvoice = ({ id, data }) => axios.put(`sub_invoices/${id}`, data)
export const attachSubValuationToSubInvoice = ({ id, subValuationId }) => axios.post(`sub_invoices/${id}/sub_valuations/${subValuationId}`)
export const detachSubValuationFromSubInvoice = ({ id, subValuationId }) => axios.delete(`sub_invoices/${id}/sub_valuations/${subValuationId}`)
